 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~admin~modules-administrator~modules-banner~modules-brand~modules-business-category-list~modu~8ae7591c":"default~admin~modules-administrator~modules-banner~modules-brand~modules-business-category-list~modu~8ae7591c","default~admin~modules-administrator~modules-banner~modules-brand~modules-business-category-list~modu~d2d563e2":"default~admin~modules-administrator~modules-banner~modules-brand~modules-business-category-list~modu~d2d563e2","default~modules-administrator~modules-coupon-distributor~modules-customer~modules-delivery-man~modul~81c76aff":"default~modules-administrator~modules-coupon-distributor~modules-customer~modules-delivery-man~modul~81c76aff","modules-login":"modules-login","modules-inventory":"modules-inventory","default~admin~modules-administrator~modules-banner~modules-brand~modules-business-category-list~modu~d391cb9c":"default~admin~modules-administrator~modules-banner~modules-brand~modules-business-category-list~modu~d391cb9c","common":"common","admin":"admin","default~modules-administrator~modules-banner~modules-brand~modules-business-category-list~modules-ca~fb47cc1a":"default~modules-administrator~modules-banner~modules-brand~modules-business-category-list~modules-ca~fb47cc1a","default~modules-administrator~modules-coupon-distributor~modules-customer~modules-delivery-man~modul~668b584c":"default~modules-administrator~modules-coupon-distributor~modules-customer~modules-delivery-man~modul~668b584c","modules-administrator":"modules-administrator","modules-customer":"modules-customer","modules-delivery-man":"modules-delivery-man","modules-team-leader":"modules-team-leader","default~modules-banner~modules-brand~modules-business-category-list~modules-category~modules-collect~eeade7c4":"default~modules-banner~modules-brand~modules-business-category-list~modules-category~modules-collect~eeade7c4","default~modules-coupon~modules-coupon-distributor~modules-dashboard~modules-event~modules-order~web~~819835f2":"default~modules-coupon~modules-coupon-distributor~modules-dashboard~modules-event~modules-order~web~~819835f2","default~modules-collection~modules-enquiry~modules-marketing-page~modules-menu~modules-order~modules-product":"default~modules-collection~modules-enquiry~modules-marketing-page~modules-menu~modules-order~modules-product","default~modules-order~web-modules-event":"default~modules-order~web-modules-event","modules-order":"modules-order","default~modules-coupon~modules-coupon-distributor~web-modules-profile":"default~modules-coupon~modules-coupon-distributor~web-modules-profile","default~modules-coupon~modules-coupon-distributor":"default~modules-coupon~modules-coupon-distributor","modules-coupon-distributor":"modules-coupon-distributor","default~modules-banner~modules-brand~modules-category~modules-collection~modules-configuration~modul~2baaed15":"default~modules-banner~modules-brand~modules-category~modules-collection~modules-configuration~modul~2baaed15","default~modules-banner~modules-brand~modules-category~modules-collection~modules-enquiry~modules-eve~37aec932":"default~modules-banner~modules-brand~modules-category~modules-collection~modules-enquiry~modules-eve~37aec932","default~modules-brand~modules-category~modules-collection~modules-dashboard~modules-enquiry~modules-~3252701d":"default~modules-brand~modules-category~modules-collection~modules-dashboard~modules-enquiry~modules-~3252701d","default~modules-brand~modules-category~modules-collection~modules-enquiry~modules-event-category~mod~588233c2":"default~modules-brand~modules-category~modules-collection~modules-enquiry~modules-event-category~mod~588233c2","default~modules-brand~modules-category~modules-collection~modules-enquiry~modules-marketing-page~mod~72904f3e":"default~modules-brand~modules-category~modules-collection~modules-enquiry~modules-marketing-page~mod~72904f3e","default~modules-brand~modules-file-manager":"default~modules-brand~modules-file-manager","modules-brand":"modules-brand","modules-menu":"modules-menu","modules-event-category":"modules-event-category","default~modules-collection~modules-enquiry~modules-event~modules-marketing-page~modules-page~modules-product":"default~modules-collection~modules-enquiry~modules-event~modules-marketing-page~modules-page~modules-product","modules-page":"modules-page","modules-banner":"modules-banner","modules-feature-product":"modules-feature-product","default~modules-collection~modules-enquiry~modules-event~modules-marketing-page~modules-product~web~~4b9197ea":"default~modules-collection~modules-enquiry~modules-event~modules-marketing-page~modules-product~web~~4b9197ea","default~modules-collection~modules-configuration~modules-dashboard~modules-enquiry~modules-event~mod~6099a4ed":"default~modules-collection~modules-configuration~modules-dashboard~modules-enquiry~modules-event~mod~6099a4ed","default~modules-collection~modules-enquiry~modules-marketing-page~modules-product~modules-technical-~26fdd18b":"default~modules-collection~modules-enquiry~modules-marketing-page~modules-product~modules-technical-~26fdd18b","default~modules-collection~modules-enquiry~modules-input~modules-marketing-page~modules-product":"default~modules-collection~modules-enquiry~modules-input~modules-marketing-page~modules-product","default~modules-collection~modules-enquiry~modules-marketing-page~modules-product":"default~modules-collection~modules-enquiry~modules-marketing-page~modules-product","modules-enquiry":"modules-enquiry","modules-collection":"modules-collection","modules-marketing-page":"modules-marketing-page","default~modules-dashboard~modules-event":"default~modules-dashboard~modules-event","modules-event":"modules-event","modules-technical-book":"modules-technical-book","modules-video":"modules-video","modules-business-category-list":"modules-business-category-list","modules-tutorial":"modules-tutorial","modules-shipping-zone":"modules-shipping-zone","modules-configuration":"modules-configuration","modules-coupon":"modules-coupon","modules-notification":"modules-notification","modules-subscription":"modules-subscription","modules-file-manager":"modules-file-manager","default~web~web-modules-about-us~web-modules-buy-again~web-modules-checkout~web-modules-contact-us~w~20963589":"default~web~web-modules-about-us~web-modules-buy-again~web-modules-checkout~web-modules-contact-us~w~20963589","default~web~web-modules-home~web-modules-marketing-page~web-modules-product~web-modules-profile~web-~8c43ce84":"default~web~web-modules-home~web-modules-marketing-page~web-modules-product~web-modules-profile~web-~8c43ce84","default~web~web-modules-home~web-modules-product":"default~web~web-modules-home~web-modules-product","default~web~web-modules-checkout":"default~web~web-modules-checkout","default~web~web-modules-marketing-page":"default~web~web-modules-marketing-page","web":"web","default~web-modules-about-us~web-modules-checkout~web-modules-contact-us~web-modules-enquiry~web-mod~9e439a59":"default~web-modules-about-us~web-modules-checkout~web-modules-contact-us~web-modules-enquiry~web-mod~9e439a59","default~web-modules-event~web-modules-home~web-modules-marketing-page~web-modules-product~web-module~ef0fcdb7":"default~web-modules-event~web-modules-home~web-modules-marketing-page~web-modules-product~web-module~ef0fcdb7","default~web-modules-home~web-modules-product~web-modules-technical-book~web-modules-video":"default~web-modules-home~web-modules-product~web-modules-technical-book~web-modules-video","default~web-modules-home~web-modules-product~web-modules-profile~web-modules-technical-book":"default~web-modules-home~web-modules-product~web-modules-profile~web-modules-technical-book","default~web-modules-event~web-modules-home~web-modules-product":"default~web-modules-event~web-modules-home~web-modules-product","default~web-modules-home~web-modules-product~web-modules-video":"default~web-modules-home~web-modules-product~web-modules-video","default~web-modules-home~web-modules-product~web-modules-technical-book":"default~web-modules-home~web-modules-product~web-modules-technical-book","default~web-modules-checkout~web-modules-home~web-modules-product":"default~web-modules-checkout~web-modules-home~web-modules-product","default~web-modules-home~web-modules-product":"default~web-modules-home~web-modules-product","default~web-modules-event~web-modules-home":"default~web-modules-event~web-modules-home","web-modules-home":"web-modules-home","modules-dashboard":"modules-dashboard","default~web-modules-checkout~web-modules-contact-us~web-modules-enquiry~web-modules-profile":"default~web-modules-checkout~web-modules-contact-us~web-modules-enquiry~web-modules-profile","default~web-modules-checkout~web-modules-profile":"default~web-modules-checkout~web-modules-profile","web-modules-profile":"web-modules-profile","modules-input":"modules-input","default~web-modules-buy-again~web-modules-checkout~web-modules-enquiry~web-modules-shopping-cart~web~25593f89":"default~web-modules-buy-again~web-modules-checkout~web-modules-enquiry~web-modules-shopping-cart~web~25593f89","default~web-modules-buy-again~web-modules-checkout~web-modules-enquiry~web-modules-shopping-cart":"default~web-modules-buy-again~web-modules-checkout~web-modules-enquiry~web-modules-shopping-cart","default~web-modules-checkout~web-modules-shopping-cart":"default~web-modules-checkout~web-modules-shopping-cart","web-modules-checkout":"web-modules-checkout","web-modules-enquiry":"web-modules-enquiry","web-modules-buy-again":"web-modules-buy-again","web-modules-viewed-item":"web-modules-viewed-item","web-modules-wishlist":"web-modules-wishlist","web-modules-contact-us":"web-modules-contact-us","web-modules-about-us":"web-modules-about-us","default~web-modules-forget-password~web-modules-login~web-modules-register":"default~web-modules-forget-password~web-modules-login~web-modules-register","web-modules-register":"web-modules-register","web-modules-forget-password":"web-modules-forget-password","web-modules-login":"web-modules-login","web-modules-event":"web-modules-event","web-modules-marketing-page":"web-modules-marketing-page","web-modules-page":"web-modules-page"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
